export default __webpack_public_path__ + "media/images/mailer-new/heading/key-added-f91f61227e7551cbe023e2fafac1beb9.png";